import script from "./SatCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./SatCertificate.vue?vue&type=script&setup=true&lang=js"

import "./SatCertificate.vue?vue&type=style&index=0&id=7d3a9426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3a9426"]])

export default __exports__